<template>
  <table class="detailed-results table table-striped table-responsive table-hover">
    <thead>
      <tr>
        <th scope="col">Category</th>
        <th scope="col">Score</th>
        <th scope="col">Mark</th>
        <th scope="col"># Unanswered</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(result,index) in visibleResults" :key="index"  >
          <td>{{ result.category_description }}</td>
          <td v-text="result.score+'%'"></td>
          <td v-text="result.right_answered_count + '/' + result.total_count"></td>
          <td v-text="result.not_answered_count"></td>
      </tr>
    </tbody>
  </table>
</template>


<script>
export default {
  props: ["results"],
  computed: {
    visibleResults(){
        return this.results.filter((item) => {
          return item.category_visible_in_breakdown
        })
    }
  }
};
</script>
